import { Injectable } from '@angular/core'
import { PresenterMode } from './presenter-context.token'
import { PresenterContextEnum } from './presenter-context.enum'

@Injectable({ providedIn: 'root' })
export class PresenterContextService {
  private _mode: PresenterMode = PresenterContextEnum.AUCTION
  private _templateUuid?: string

  get mode(): PresenterMode {
    return this._mode
  }

  get isTemplateMode(): boolean {
    return this._mode === PresenterContextEnum.TEMPLATE
  }

  get templateUuid(): string | undefined {
    return this._templateUuid
  }

  setMode(mode: PresenterContextEnum): void {
    this._mode = mode
  }

  setTemplateUuid(uuid: string | undefined): void {
    this._templateUuid = uuid
  }
}
